export type { ListPartnerProps } from './Partner'
export { default as ListPartner } from './Partner'
